/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Status_Incomplete_ExpiredInputs */

const fr_membership_status_incomplete_expired = /** @type {(inputs: Membership_Status_Incomplete_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résilié`)
};

/**

* @param {Membership_Status_Incomplete_ExpiredInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_status_incomplete_expired = /** @type {((inputs?: Membership_Status_Incomplete_ExpiredInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Status_Incomplete_ExpiredInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_status_incomplete_expired(inputs)
});